<template>
  <div class="item-standart">
    <div class="avatar">
      <child-avatar size="small"
                    icon-color="#fff"
                    icon-background-color="#7962B4"
                    :icon="icon"
                    :child="item.user"
                    :show-status="false" />
    </div>
    <div class="content">
      <div class="description one-liner">
        {{ displayedAction }}
      </div>
      <div class="details">
        <feed-item-details :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
  import ItemBase from './ItemBase.vue'

  export default {
    extends: ItemBase,

    props: {
      item: {
        required: true,
        type: Object
      }
    },

    computed: {
      ...mapGetters('geofence', {
        getNamedLocationById: 'getNamedLocationById'
      }),

      location() {
        return this.getNamedLocationById(Number(this.item.details.named_location_id))
      },

      eventType() {
        return this.item.details.action
      },

      displayedAction() {
        if (this.location && this.eventType === 'enter') {
          return this.$t("feed.item.geofenceItemArrived", { location: this.location.name })
        }

        if (this.location && this.eventType === 'exit') {
          return this.$t("feed.item.geofenceItemLeft", { location: this.location.name })
        }

        return ''
      },

      icon() {
        return this.eventType === 'enter' ? 'IconTick' : 'IconArrowRight2'
      }
    }
  }
</script>
